import React, { useEffect, useState, useContext } from "react";

export const BoatAnatomy = (props) => {

    const videoBoatAnatomyEng = "https://fwm.ferrettigroup.com/asset/fwm/upload/configurator/videos/infynito80/boat-anatomy-eng.mp4";
    const videoBoatAnatomyIta = "https://fwm.ferrettigroup.com/asset/fwm/upload/configurator/videos/infynito80/boat-anatomy-ita.mp4";
    const posterImage = "https://fwm.ferrettigroup.com/asset/fwm/upload/configurator/videos/infynito80/poster-boat-anatomy.jpg";

    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container py-5" id="Boatanatomy">
                    <div className="row vh-lg-100">
                        <div className="col-12" data-aos="zoom-in" data-aos-duration="1500">
                            <div className="row justify-content-center h-100">
                                <div className="col-12">
                                    <div className="valign">
                                        <div className="align-middle d-table-cell">
                                            <div className="d-table mx-auto position-relative bkg-video">
                                                <h2 className="text-uppercase text-center text-white mb-3">Boat Anatomy</h2>
                                                <p className="text-center text-white">Explore INFYNITO 80 from a new perspective with Boat Anatomy: an exclusive journey through every deck, discovering every detail.</p>
                                                <video className="video-boat-anatomy w-100" poster={posterImage} controls>
                                                    <source src={videoBoatAnatomyEng} type="video/mp4" />
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {props.cultureCode === "it-it" &&
                <div className="container py-5" id="Boatanatomy">
                    <div className="row vh-lg-100">
                        <div className="col-12" data-aos="zoom-in" data-aos-duration="1500">
                            <div className="row justify-content-center h-100">
                                <div className="col-12">
                                    <div className="valign">
                                        <div className="align-middle d-table-cell">
                                            <div className="d-table mx-auto position-relative bkg-video">
                                                <h2 className="text-uppercase text-center text-white mb-3">Boat Anatomy</h2>
                                                <p className="text-center text-white">Esplora INFYNITO 80 da una prospettiva inedita con Boat Anatomy: un viaggio esclusivo attraverso ogni ponte, alla scoperta di ogni dettaglio.</p>
                                                <video className="video-boat-anatomy w-100" poster={posterImage} controls>
                                                    <source src={videoBoatAnatomyIta} type="video/mp4" />
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    );




};

export default BoatAnatomy;